var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs---Tally-ETA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropdown",
    transform: "translate(-16.000000, -26.000000)",
    stroke: "#51AF2B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-",
    transform: "translate(12.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1362932,8.29948718 L13.808547,8.29948718 L16.4433048,13.8324786 L3.55271368e-15,13.8324786 L2.63475783,8.29948718 C3.1610144,8.29948718 3.0938103,8.29948718 4.43314555,8.29948718",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22165242,-1.72306613e-13 C5.58785525,-1.72306613e-13 3.45274074,2.13511449 3.45274074,4.76891168 C3.45274074,9.06356697 8.22165242,13.2791795 8.22165242,13.2791795 C8.22165242,13.2791795 12.9905641,9.06356697 12.9905641,4.76891168 C12.9905641,2.13511449 10.8554496,-1.72306613e-13 8.22165242,-1.72306613e-13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.22165242,
    cy: 4.7425641,
    r: 1.5808547
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0cc932af528eddf01a122eeb1d5e561a.svg";
export { ForwardRef as ReactComponent };